import React from "react";
import { HomeView } from "../../views/HomeView";
import HomeIcon from "@material-ui/icons/Home";
import { FaqView } from "../../views/faq/FaqView";
import { ContactView } from "../../views/ContactView";
import { ProductOverview } from "../../views/ProductOverview";
import { UseCasesView } from "../../views/useCases/UseCasesView";

export interface IMenuItem {
    path: string;
    url?: string;
    labelId?: string;
    icon?: JSX.Element;
    component: JSX.Element;
}

export const mainNavBarItems: IMenuItem[] = [
    {
        icon: <HomeIcon />,
        path: "/",
        component: <HomeView />,
    },
    {
        path: "/products",
        labelId: "mainNavBar.productView",
        component: <ProductOverview />,
    },
    {
        url: "/use-cases",
        path: "/use-cases/:categoryId?",
        labelId: "Use cases",
        component: <UseCasesView />
    },
    {
        path: "/faq",
        labelId: "FAQ",
        component: <FaqView />
    },
    {
        path: "/contact",
        labelId: "headerBar.contact",
        component: <ContactView />
    }
];
